export const API_BASE_URL = (import.meta.env.VITE_API_URL || 'https://serendib-go-travel-management-web-s.vercel.app').replace(/\/$/, '');


